import type { IconSvgObject } from './types';

const CongruentToSquareIcon: IconSvgObject = [
  ["path", { d: "M7 12.5H17M7 16H17M7 9.50001C8 7.63648 10.3333 7.54353 12 8.99999M17 8.49503C16 10.3586 13.6667 10.4515 12 8.99505", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50043C21.5 3.39589 20.6046 2.50046 19.5001 2.50043L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CongruentToSquareIcon;
